const cloudFunction = (endpoint: string) : string => {
  if (WEBPACK_ENV === 'development') {
    return `http://localhost:9011/${endpoint}`;
  }

  return `https://${GCP_FUNCTIONS_HOST}/${endpoint}`;
}

export default cloudFunction;
